/* eslint-disable import/prefer-default-export */
import { ApolloCache } from "@apollo/client";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { groupBy } from "lodash";
import { addNewRecordsWithFieldSpec } from "utils/apollo/cacheHelpers";

const cacheUpdateFragment = gql(/* GraphQL */ `
  fragment CreateDistributionCenterCacheUpdate on DistributionCenter {
    id
    orderingPlatformId
  }
`);

export function newDistributionCenterCacheUpdate(
  cache: ApolloCache<unknown>,
  newDistributionCenter:
    | FragmentType<typeof cacheUpdateFragment>
    | FragmentType<typeof cacheUpdateFragment>[],
) {
  const newDcs = getFragmentData(
    cacheUpdateFragment,
    Array.isArray(newDistributionCenter)
      ? newDistributionCenter
      : [newDistributionCenter],
  );

  const byOrderingPlatformId = groupBy(newDcs, "orderingPlatformId");

  Object.keys(byOrderingPlatformId).forEach((orderingPlatformId) => {
    const newDcsForOrderingPlatformId =
      byOrderingPlatformId[orderingPlatformId];

    addNewRecordsWithFieldSpec({
      baseFieldName: "distributionCenters",
      cache,
      id: orderingPlatformId,
      newObjs: newDcsForOrderingPlatformId,
      typename: "OrderingPlatform",
    });

    addNewRecordsWithFieldSpec({
      baseFieldName: "distributionCenters",
      cache,
      newObjs: newDcsForOrderingPlatformId,
      getArgs: (defaultArgs) => [
        defaultArgs,
        {
          ...defaultArgs,
          filter: {
            orderingPlatformId: { equalTo: orderingPlatformId },
          },
        },
      ],
    });
  });
}
